import { format, isValid, parse, parseISO } from 'date-fns';

export function parseDate(dateString: string | null): Date | null {
  if (!dateString) {
    return null;
  }
  try {
    const date = dateString.includes('T')
      ? parseISO(dateString)
      : parse(dateString, 'yyyy-MM-dd', new Date());
    return isValid(date) ? date : null;
  } catch {
    return null;
  }
}

/**
 * Formats a Date object to 'yyyy-MM-dd' string for input fields.
 * Uses local timezone to avoid UTC conversion issues.
 */
export function formatDateForInput(date: Date | null): string {
  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }
  return format(date, 'yyyy-MM-dd');
}
